<template>
  <div class="col">
    <div class="row">
      <h2>Crédits</h2>
    </div>
    <div class="row">
      Auteur :&nbsp;
      <a
        href="mailto:morgan.denis.60@gmail.com"
        target="_blank"
      >morgan.denis.60@gmail.com</a>
    </div>
    <div class="row">
      Framework :&nbsp;
      <a
        href="https://vuejs.org"
        target="_blank"
      >Vue.js</a>
    </div>
    <div class="row">
      Store :&nbsp;
      <a
        href="https://vuex.vuejs.org/"
        target="_blank"
      >Vuex</a>
    </div>
    <div class="row">
      Stockage :&nbsp;
      <a
        href="https://firebase.google.com"
        target="_blank"
      >Firebase</a>
    </div>
    <div class="row">
      Données :&nbsp;
      <a
        href="https://fr.numista.com/"
        target="_blank"
      >Numista</a>
    </div>
    <div class="row">
      API d'accès au données :&nbsp;
      <a
        href="http://qmegas.info/numista-api/"
        target="_blank"
      >Numpista API</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Credit'
  };
</script>

<style scoped>
    a {
        color: inherit;
    }

    .row {
        justify-content: center;
    }
</style>
